import * as Yup from 'yup'

const brandDefinitionTaskSchema = Yup.object().shape({
  brand: Yup.object().shape({
    name: Yup.string()
      .required(`Brand's name is required`)
      .nullable(),
    website: Yup.string()
      .when('isHasNoWebsiteConfirmed', {
        is: isHasNoWebsiteConfirmed => !isHasNoWebsiteConfirmed,
        then: Yup.string()
          .url('Website is not valid')
          .required('Brand website is required')
          .nullable(),
      })
      .nullable(),
  }),
})

export default brandDefinitionTaskSchema
